<div [formGroup]="parentForm">
  <div class="flex" [ngClass]="radioAlign">
    @for (item of radioList; track item.id; let i = $index) {
      <label
        class="inline-flex items-center mt-1 mr-4 cursor-pointer"
        >
        <input
          type="radio"
          [id]="item.id"
          [name]="item.name"
          [attr.disabled]="item.disabled ? '' : null"
          (change)="valueChange($event)"
          [class]="item.radioClass"
          [required]="item.required"
          [value]="item.id"
          [checked]="item.checked"
          [formControlName]="item.control"
          />
          <span [class]="item.labelClass">{{ item.label }}</span>
        </label>
      }
    </div>
  </div>
